import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { SparklesIcon } from 'lucide-react';
export function PromoBanner() {
  const navigate = useNavigate();
  return <section className="bg-jet relative overflow-hidden shadow-xl z-20 border-y border-brown/20" data-id="element-228">
      {/* Decorative background pattern */}
      <div className="absolute inset-0 pattern-african opacity-10 mix-blend-overlay pointer-events-none" data-id="element-229"></div>

      {/* Blended image - positioned absolutely so it integrates naturally */}
      <motion.div initial={{
      opacity: 0
    }} whileInView={{
      opacity: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 1.2
    }} className="absolute left-0 top-0 w-[28rem] h-full pointer-events-none hidden lg:flex items-center z-10" data-id="element-230">
        <img src="https://cdn.magicpatterns.com/uploads/ea6wGCCMy3jEKUh6o4rMpU/istockphoto-1487044526-612x612-removebg-preview.png" alt="" className="w-[28rem] h-auto object-contain opacity-75 ml-2" style={{
        maskImage: 'linear-gradient(to bottom, black 50%, transparent 100%), linear-gradient(to right, black 60%, transparent 100%)',
        WebkitMaskImage: 'linear-gradient(to bottom, black 50%, transparent 100%), linear-gradient(to right, black 60%, transparent 100%)',
        maskComposite: 'intersect',
        WebkitMaskComposite: 'destination-in'
      }} data-id="element-231" />
      </motion.div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 relative z-10" data-id="element-232">
        <div className="flex flex-col items-center lg:items-start gap-8 lg:pl-72" data-id="element-233">
          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8
        }} className="flex flex-col lg:flex-row items-center gap-6 text-center lg:text-left" data-id="element-234">
            <div className="w-16 h-16 rounded-full bg-brown/20 flex items-center justify-center shrink-0 border border-burgundy/30 shadow-inner" data-id="element-235">
              <SparklesIcon className="w-8 h-8 text-burgundy" data-id="element-236" />
            </div>
            <div data-id="element-237">
              <h3 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-cream mb-3 text-glow leading-tight" data-id="element-238">
                <span className="text-golden" data-id="element-239">$10 OFF</span> Braids $80+
                <br data-id="element-240" />
                <span className="text-golden" data-id="element-241">$20 OFF</span> Braids $180+
              </h3>
              <p className="text-cream/60 text-lg md:text-xl font-medium" data-id="element-242">
                Elevate your style with our premium services. Walk-ins
                welcome—mention this promo!
              </p>
            </div>
          </motion.div>

          {/* CTA - below content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="w-full flex justify-center" data-id="element-243">
            <button onClick={() => navigate('/booking')} className="w-full sm:w-auto bg-gradient-to-r from-burgundy to-brown text-cream hover:from-brown hover:to-burgundy px-10 py-5 rounded-sm font-bold transition-all shadow-lg text-lg uppercase tracking-wider glow-pink" data-id="element-244">
              Claim Offer
            </button>
          </motion.div>
        </div>
      </div>
    </section>;
}